// Funkcija za učitavanje iz localStorage ili vraćanje default vrijednosti
const loadTours = () => {
  const saved = localStorage.getItem("travelina_tours");
  if (saved) {
    try {
      const tours = JSON.parse(saved);
      // Ažuriraj putanje slika ako su stare
      return tours.map((tour) => {
        if (tour.key === "valladolid" && tour.image !== "/images/valladolid.jpg") {
          tour.image = "/images/valladolid.jpg";
        }
        if (tour.key === "alicante" && tour.image !== "/images/alicante.jpg") {
          tour.image = "/images/alicante.jpg";
        }
        // Osiguraj da blogText postoji
        if (!tour.blogText) {
          tour.blogText = { hr: "", en: "", de: "", es: "" };
        }
        return tour;
      });
    } catch (e) {
      console.error("Error loading tours from localStorage", e);
    }
  }
  return [
    {
      id: 1,
      key: "valladolid",
      category: "city",
      days: 4,
      nights: 3,
      country: "Spain",
      date: "2026-02-01",
      price: 650,
      tag: "New",
      image: "/images/valladolid.jpg",
      blogText: {
        hr: "",
        en: "",
        de: "",
        es: "",
      },
    },
    {
      id: 2,
      key: "alicante",
      category: "beach",
      days: 5,
      nights: 4,
      country: "Spain",
      date: "2026-03-15",
      price: 750,
      tag: "Popular",
      image: "/images/alicante.jpg",
      blogText: {
        hr: "",
        en: "",
        de: "",
        es: "",
      },
    },
  ];
};

export let tours = loadTours();

// Funkcija za spremanje u localStorage
export const saveTours = (updatedTours) => {
  tours = updatedTours;
  localStorage.setItem("travelina_tours", JSON.stringify(updatedTours));
};
